import { CSE_MESSAGES_API_ENDPOINTS } from "@/features/cse-messages/configs/cseMessagesApiPath.config";
import type {
  CseMessage,
  CseMessagePayload,
  DismissCseMessageResponse,
  GetCseMessagesResponse,
} from "@/features/cse-messages/types/cseMessage.type";
import { fetcher } from "@/shared/lib/fetcher.client";

// L'API sérialise cover_image comme une pièce jointe ActiveStorage (objet
// { url, large_url, ... }) : sans normalisation, l'image de couverture ne
// s'affiche jamais. On la ramène à une URL.
const toCoverImageUrl = (coverImage: CseMessagePayload["cover_image"]): string | null => {
  if (typeof coverImage === "string") {
    return coverImage || null;
  }
  if (!coverImage || typeof coverImage !== "object") {
    return null;
  }
  const url = coverImage.large_url || coverImage.url;
  return typeof url === "string" && url ? url : null;
};

export const getCseMessages = async (): Promise<CseMessage[]> => {
  const response = await fetcher.get<GetCseMessagesResponse>(CSE_MESSAGES_API_ENDPOINTS.GET_CSE_MESSAGES);
  return response.data.cse_messages.map((message) => ({
    ...message,
    cover_image: toCoverImageUrl(message.cover_image),
  }));
};

export const dismissCseMessage = async (messageId: string): Promise<DismissCseMessageResponse> => {
  const response = await fetcher.patch<DismissCseMessageResponse>(
    CSE_MESSAGES_API_ENDPOINTS.DISMISS_CSE_MESSAGE.replace(":messageId", messageId),
  );
  return response.data;
};
